import PropTypes from 'prop-types';

import Box from 'shopper/components/Box';

import Layout from 'components/Layout';
import StoresTabNav from 'components/Store/StoresTabNav';

import placeholder from 'lib/placeholder';

import SiteMapBlackFridayLandingsList from './BlackFridayLandingsList';
import SiteMapCategoriesList from './CategoriesList';
import SiteMapHeading from './Heading';
import Schema from './Schema';

import STORES from 'constants/store';

const GA_EVENT_CATEGORY = 'sitemap';

const SiteMap = ({ categories, blackFridayLandings }) => (
  <>
    <Schema />
    <Layout
      gaEventCategory={GA_EVENT_CATEGORY}
      headingComponent={
        <SiteMapHeading title={placeholder('titles.allCategories')} />
      }
      withGridLayout={false}
      maxWidthOnMobileDevices
      scrollToTopButton
    >
      <Box className="px-4 py-10 md:px-20 md:py-16">
        <StoresTabNav activeTabName={STORES.TABS.CATEGORIES.tabName} />
        <SiteMapCategoriesList categories={categories} />
        <SiteMapBlackFridayLandingsList
          blackFridayLandings={blackFridayLandings}
        />
      </Box>
    </Layout>
  </>
);

SiteMap.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      categoryId: PropTypes.number,
      categoryName: PropTypes.string.isRequired,
      categoryUrl: PropTypes.string.isRequired,
      groupId: PropTypes.number.isRequired,
      groupName: PropTypes.string.isRequired,
      subcategories: PropTypes.arrayOf(
        PropTypes.shape({
          subcategoryId: PropTypes.number.isRequired,
          subcategoryName: PropTypes.string.isRequired,
          subcategoryParam: PropTypes.string.isRequired,
        })
      ),
    })
  ).isRequired,
  blackFridayLandings: PropTypes.arrayOf(
    PropTypes.shape({
      landingId: PropTypes.number.isRequired,
      landingTitle: PropTypes.string.isRequired,
      landingSlug: PropTypes.string.isRequired,
      landingName: PropTypes.string.isRequired,
      landingIsFeatured: PropTypes.bool.isRequired,
      landingIsHighlighted: PropTypes.bool.isRequired,
      landingType: 'BLACK_FRIDAY',
    })
  ).isRequired,
};

export default SiteMap;
